const SITE_NAME = "Alex Rodriguez | Software Developer";
const SITE_DESCRIPTION =
  "Portfolio of Alex Rodriguez, Software Developer at CHECK24 in Augsburg, Germany. Full-stack developer with experience in PHP, React, Docker, CI/CD, and enterprise web applications.";
const SITE_IMAGE = "/logo512.png";

function upsertMeta(attr, key, value) {
  if (!value) return;

  let element = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attr, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", value);
}

function upsertLink(rel, href, extra = {}) {
  if (!href) return;

  let element = document.head.querySelector(`link[rel="${rel}"]`);
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", rel);
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
  Object.entries(extra).forEach(([key, value]) => {
    element.setAttribute(key, value);
  });
}

export function applyDynamicSeo() {
  const siteUrl =
    process.env.REACT_APP_SITE_URL?.replace(/\/$/, "") ||
    window.location.origin;
  const canonicalUrl = `${siteUrl}/`;
  const imageUrl = `${siteUrl}${SITE_IMAGE}`;

  document.title = SITE_NAME;

  upsertMeta("name", "description", SITE_DESCRIPTION);
  upsertLink("canonical", canonicalUrl);
  upsertMeta("property", "og:url", canonicalUrl);
  upsertMeta("property", "og:title", SITE_NAME);
  upsertMeta("property", "og:description", SITE_DESCRIPTION);
  upsertMeta("property", "og:image", imageUrl);
  upsertMeta("name", "twitter:url", canonicalUrl);
  upsertMeta("name", "twitter:title", SITE_NAME);
  upsertMeta("name", "twitter:description", SITE_DESCRIPTION);
  upsertMeta("name", "twitter:image", imageUrl);
}
